/**
 * Nano Banana Pro（gemini-3-pro-image）manifest
 * 数据来源：image.json field_map
 * 特点：1K/2K/4K 三档清晰度（三档比例选项一致，均无真实像素）；参考图上限 14；支持 @ 参考图
 */
import type { ImageModelConfig, ImageRatioOption } from '../../types';

/** 三档共用的比例选项（接口 field_map 中 1K/2K/4K 各自列出但内容一致） */
const RATIOS: ImageRatioOption[] = [
  { label: '1:1', value: '1:1' },
  { label: '2:3', value: '2:3' },
  { label: '3:2', value: '3:2' },
  { label: '3:4', value: '3:4' },
  { label: '4:3', value: '4:3' },
  { label: '9:16', value: '9:16' },
  { label: '16:9', value: '16:9' },
  { label: '21:9', value: '21:9' },
];

export const nanoBananaPro: ImageModelConfig = {
  id: '01KBER8AQ1Z0ZV5KFQH71V16CH',
  displayName: 'Nano Banana Pro',

  defaults: {
    ratio: '9:16', // 接口各档 select: true 项
    resolution: '2K', // 接口 resolution.default
  },

  ratioOptions: {
    '1K': RATIOS,
    '2K': RATIOS,
    '4K': RATIOS,
  },

  resolutionOptions: [
    { label: '标清 1K', value: '1K' },
    { label: '高清 2K', value: '2K' },
    { label: '超清 4K', value: '4K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label

  qualityOptions: [],

  // 支持 @ 参考图（Banana 系列）
  supportAtMention: true,

  toggles: {},

  limits: {
    maxRefImages: 14, // 接口 field_map.ref_images.max
  },
};
